import React from 'react';

import {
  OrganizationRole,
  organizationRoleLabels,
} from '@neptune/shared/core-organizations-domain';
import { ProjectRole, projectRoleLabels } from '@neptune/shared/core-project-domain';
import {
  bemBlock,
  Checkbox,
  type CheckboxProps,
  Icon,
  InfoIcon,
  SimpleTooltip,
  Text,
} from '@neptune/shared/venus-ui';

import './AddToAllProjects.less';

export type AddToAllProjectsProps = Pick<CheckboxProps, 'checked' | 'onChange'> & {
  role: string;
};

const block = bemBlock('n-AddToAllProjects');

export const AddToAllProjects: React.FC<AddToAllProjectsProps> = ({ checked, onChange, role }) => {
  const isOwner = role === OrganizationRole.owner;

  return (
    <Checkbox
      disabled={isOwner}
      checked={isOwner || checked}
      onChange={onChange}
      role="add-to-all-projects"
    >
      {isOwner ? (
        <>
          <SimpleTooltip
            placement="bottom-center"
            content={
              <>
                {organizationRoleLabels[OrganizationRole.owner]} of a Workspace is granted{' '}
                <Text italic>{projectRoleLabels[ProjectRole.manager]}</Text> access to all projects
                automatically.
              </>
            }
          >
            <Text className={block({ element: 'label' })}>Add to all projects</Text>
          </SimpleTooltip>
        </>
      ) : (
        <>
          <Text>Add to all projects</Text>{' '}
          <InfoIcon triggerElement={<Icon glyph="question-circle" color="text-action" />}>
            By selecting this option, you grant this user{' '}
            <Text italic>{projectRoleLabels[ProjectRole.member].toLowerCase()}</Text> access to all
            currently existing projects. You can also add{' '}
            {organizationRoleLabels[OrganizationRole.member].toLowerCase()}s to particular projects
            later, through the project settings.
          </InfoIcon>
        </>
      )}
    </Checkbox>
  );
};
